import { Routes } from '@angular/router';


import { ROUTES_CONSTANTS } from './constants/routes.constants';
import { NetworkTestComponent } from './pages/network-test/network-test.component';
import { MutuaNetworkTestComponent } from './pages/mutua-network-test/mutua-network-test.component';
import { RoomComponent } from './pages/room/room.component';
import { VideoconferenceMainComponent } from './pages/videoconference-main';

export const routes: Routes = [
  { path: ROUTES_CONSTANTS.NETWORK_TEST.path, component: NetworkTestComponent },
  { path: ROUTES_CONSTANTS.MUTUA_NETWORK_TEST.path, component: MutuaNetworkTestComponent },
  { path: ROUTES_CONSTANTS.ROOM.path, component: RoomComponent },
  { path: ROUTES_CONSTANTS.VIDEOCONFERENCE.path, component: VideoconferenceMainComponent },
  { path: '**', redirectTo: ROUTES_CONSTANTS.NETWORK_TEST.path, pathMatch: 'full' }
];

